// extracted by mini-css-extract-plugin
module.exports = {"heroItem":"_4e787e90","imageWrapper":"_6963441","image":"_580f4a52","title":"_2e1a67d5"};